export enum OprEntityKeys {
  GENERAL_SYSTEM = -1, // סיסטם
  BANK_HAPOALIM = 2, // בנק הפועלים
  MIZRAHI_BANK = 3, // בנק מזרחי
  AYALON_INSURANCE = 4, // איילון חברה לביטוח
  GOLD_PLUS = 5, // גולד פלוס
  MALAM_PENSION = 6, // מלמ גמל
  INTERNATIONAL_BANK = 7, // הבנק הבינלאומי
  MEITAV_DASH = 8, // מיטב דש
  LEUMI_BANK = 9, // בנק לאומי
  IAI = 10 // תעשייה אווירית
}

//סיסטם = 1
// בנק הפועלים = 2
// בנק מזרחי = 3
// איילון חברה לביטוח = 4
// גולד פלוס = 5
// מלמ גמל = 6
// הבנק הבינלאומי = 7
// מיטב דש = 8
// בנק לאומי = 9
// תעשייה אווירית = 10